
export function useSurfaceEditorStoreSelection({surfaces}) {
  const activeSurfaceId = ref(null);
  const selectedElementId = ref(null);
  const editedElementId = ref(null);

  const surfaceEditorUtils = useSurfaceEditorUtils();

  const activeSurface = computed(() => activeSurfaceId.value && surfaces.value.find(s => s.id === activeSurfaceId.value));

  const selectedElement = computed(() => selectedElementId.value
    && surfaceEditorUtils.findElementInSurface({
      elementId: selectedElementId.value,
      surfaces: surfaces.value
    })?.element
  );
  const editedElement = computed(() => editedElementId.value
    && surfaceEditorUtils.findElementInSurface({
      elementId: editedElementId.value,
      surfaces: surfaces.value
    })?.element
  );

  function setActiveSurface({surface: s}) {
    activeSurfaceId.value = s.id;
  }

  function selectElement({element: e}) {
    selectedElementId.value = e?.id;

    if (!e || e.background) {
      editedElementId.value = null;
    }
  }

  function editElement({element: e}) {
    if (e && SURFACE_EDITOR_EDITABLE_ELEMENTS.includes(e.type) && !e.background) {
      editedElementId.value = e?.id;
    } else {
      editedElementId.value = null;
    }
  }

  function clearSelection() {
    selectedElementId.value = null;
    editedElementId.value = null;
  }

  function clearActiveSurface() {
    activeSurfaceId.value = null;
  }

  return {
    activeSurface,
    selectedElement,
    editedElement,

    setActiveSurface,
    selectElement,
    editElement,
    clearSelection,
    clearActiveSurface
  };

}
